import React, { Component } from 'react';
import { connect } from 'react-redux';
import autobind from 'autobind-decorator';
import { changeTitle } from '../../actions/post';
import TextArea from 'react-textarea-autosize';
import classnames from 'classnames';
import { setTitlePlaceholderColorRed } from '../../actions';

@connect(state => ({
  post: state.post.newPost,
  blog: state.blog,
  redTitlePlaceholder: state.env.redTitlePlaceholder,
}), dispatch => ({
  handleChangeTitle: title => {
    dispatch(changeTitle(title));
    dispatch(setTitlePlaceholderColorRed(false));
  },
}))
class PostTitle extends Component {
  constructor (props) {
    super(props);

    this.titleRef = React.createRef();
  }

  componentDidMount () {
    if (this.titleRef) {
      this.titleRef.addEventListener('change', this.handleChangeTitle);
    }
  }

  componentWillUnmount () {
    if (this.titleRef) {
      this.titleRef.removeEventListener('change', this.handleChangeTitle);
    }
  }

  @autobind
  handleChangeTitle (e) {
    const { handleChangeTitle } = this.props;
    handleChangeTitle(e.target.value);
  }

  render () {
    const { post, redTitlePlaceholder } = this.props;

    return (
      <div className="post-title" >
        <TextArea inputRef={ref => this.titleRef = ref} className={classnames({ textarea_tit: true, red: redTitlePlaceholder })} placeholder="제목을 입력하세요" value={post.title} onChange={this.handleChangeTitle} />
      </div>
    );
  }
}

export default PostTitle;
